"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastMileDeliveryPriceriteAPI = void 0;

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LastMileDeliveryPriceriteAPI = /*#__PURE__*/function () {
  function LastMileDeliveryPriceriteAPI(_ref) {
    var customerKey = _ref.customerKey,
        userInformation = _ref.userInformation,
        userSetting = _ref.userSetting,
        lfToken = _ref.lfToken;
    (0, _classCallCheck2.default)(this, LastMileDeliveryPriceriteAPI);
    this.customerKey = null;
    this.userInformation = {};
    this.settings = {};
    this.lfToken = null;
    this.requestAuth = null;
    this.requestParameters = null;
    this.helper = new _helper.Helper();
    this.customerKey = customerKey;
    this.userInformation = userInformation;
    this.settings = userSetting;
    this.lfToken = lfToken;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.customerKey);
  }

  (0, _createClass2.default)(LastMileDeliveryPriceriteAPI, [{
    key: "getPlan",
    value: function getPlan(planDate) {
      return this.requestAuth.get('ROUTING', 'v1/core/lastmile', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        additionalData: 'truckType,capacity3,estimatedCapacity3,capacity4,estimatedCapacity4,capacity5,estimatedCapacity5,returnTime,returnRunningTime,estimatedReturnTime,estimatedReturnDistance',
        code: planDate
      }));
    }
  }, {
    key: "insertPlan",
    value: function insertPlan(payload) {
      return this.requestAuth.post('ROUTING', 'v1/core/lastmile', _objectSpread({}, this.requestParameters), payload);
    }
  }, {
    key: "updatePlan",
    value: function updatePlan(payload) {
      var planDate = payload['code'];
      return this.requestAuth.put('ROUTING', 'v1/core/lastmile', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        code: planDate
      }), payload);
    }
  }, {
    key: "deletePlan",
    value: function deletePlan(_ref2) {
      var payload = _ref2.payload,
          requestParams = _ref2.requestParams;
      return this.requestAuth.delete('ROUTING', 'v1/core/lastmile', _objectSpread(_objectSpread({}, this.requestParameters), requestParams), payload);
    }
  }, {
    key: "getOrdersInPlan",
    value: function getOrdersInPlan(payload) {
      var requestAuth = new _request.Request('application/json', this.lfToken);
      var hook3 = this.helper.get(this.settings, 'hook3', '');

      if (!this.helper.isUndefined(hook3)) {
        return this.requestAuth.get(hook3, '', {}, true);
      }

      return requestAuth.put('LEGACY_CORE_V3', 'routeplanning/order?formatted=true&modeType=lastmile', {}, payload);
    }
  }, {
    key: "updateOrdersInPlan",
    value: function updateOrdersInPlan(payload) {
      var requestAuth = new _request.Request('application/json', this.lfToken);
      payload['type'] = 'planning-tools-lmd';
      return requestAuth.put('LEGACY_CORE_V3', 'routeplanning/planningcode', {}, payload);
    }
  }, {
    key: "transferPlan",
    value: function transferPlan(payload) {
      return this.requestAuth.post('ROUTING', 'v1/core/lastmile/transfer', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        code: payload.code
      }), payload);
    }
  }, {
    key: "removeOrder",
    value: function removeOrder(payload) {
      return this.requestAuth.post('ROUTING', 'v1/core/lastmile/remove', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        code: payload.code
      }), payload);
    }
  }, {
    key: "getTrucks",
    value: function getTrucks(store) {
      var param = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        userId: this.userInformation['user']['id'],
        limit: 500,
        order: 'PlateNum:ASC',
        // NOTE: temporary remove job date
        // date: store.planDate,
        date: '0000-00-00'
      });

      var truckFilters = store['truckFilters'].filter(function (i) {
        return i.key !== 'TruckSchedule';
      });
      var filterQuery = this.helper.getFilterQuery(truckFilters);

      if (!this.helper.isUndefined(filterQuery.queryAnd)) {
        param['query'] = filterQuery.queryAnd;
      }

      var truckScheduleFilters = store['truckFilters'].filter(function (i) {
        return i.key === 'TruckSchedule';
      });

      if (truckScheduleFilters.length) {
        param['time'] = truckScheduleFilters[0]['value'];
      }

      var hook2 = this.helper.get(this.settings, 'hook2', '');

      if (!this.helper.isUndefined(hook2)) {
        return this.requestAuth.get(hook2, '', param, true);
      }

      var payload = {
        blockedTrucks: this.userInformation['blockedTrucks'] || []
      };
      return this.requestAuth.post('ROUTING', 'v1/core/trucksformat', param, payload);
    }
  }, {
    key: "arrayStringDefault16",
    value: function arrayStringDefault16(data) {
      var newData = [];
      data.forEach(function (obj) {
        newData.push("".concat(obj['truck'], "-").concat(obj['commodity']));
      });
      return newData.join('|');
    }
  }, {
    key: "manualAssignTransfer",
    value: function manualAssignTransfer(payload) {
      var requestParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var params = _objectSpread(_objectSpread(_objectSpread({}, this.requestParameters), requestParameters), {}, {
        // pickUpAllFirst, coming from req param
        // google: this.settings['default5'] || false,
        google: true,
        removeOverflow: this.settings['default1'] || false,
        returnVehicle: this.settings['default3'] || false,
        capacity: this.settings['default9'] || false,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        additionalConstraints: this.settings['default12'] || '',
        capacity3Data: 0,
        capacity4Data: 0,
        capacity5Data: 0
      });

      return this.requestAuth.post('ALGORITHM', 'v1/core/manualassigntransferroutes', params, payload);
    }
  }, {
    key: "manualAssign",
    value: function manualAssign(payload) {
      var requestParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isTransfer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isTimeWindowCheck = this.settings['default2'];
      var endpoint;

      var params = _objectSpread(_objectSpread(_objectSpread({}, this.requestParameters), requestParameters), {}, {
        removeOverflow: this.settings['default1'] || false,
        returnVehicle: this.settings['default3'] || false,
        capacity: this.settings['default9'] || false,
        // google: this.settings['default5'] || false,
        google: true,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        maxTime: 24,
        capacity3Data: this.settings['default15'] || 0,
        commodityTruckData: this.settings['default16'] ? this.arrayStringDefault16(this.settings['default16']) : '',
        additionalConstraints: this.settings['default12'] || '',
        noValidation: isTransfer
      });

      if (isTimeWindowCheck) {
        endpoint = 'v1/core/manualassigntimewindow';
        params['timeWindowBuffer'] = this.settings['default13'] || 0;
        params['groupByTimeWindow'] = this.settings['default24'] || false;
        params['groupByWeekDate'] = this.settings['default32'] || false;
      } else {
        endpoint = 'v1/core/manualassign';
      }

      return this.requestAuth.post('ALGORITHM', endpoint, params, payload);
    }
  }, {
    key: "autoAssign",
    value: function autoAssign(payload) {
      var requestParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var locationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'drop';
      var endpoint = 'v1/core/pricerite/autoassign';

      var params = _objectSpread(_objectSpread(_objectSpread({}, this.requestParameters), requestParameters), {}, {
        removeOverflow: true,
        returnVehicle: this.settings['default3'] || false,
        optimizeTruck: false,
        capacity: this.settings['default9'] || false,
        group: this.settings['default4'] || false,
        // google: this.settings['default5'] || false,
        google: true,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        maxTime: 24,
        capacity3Data: this.settings['default15'] || 0,
        commodityTruckData: this.settings['default16'] ? this.arrayStringDefault16(this.settings['default16']) : '',
        additionalConstraints: this.settings['default12'] || '',
        priorityCount: this.settings['default25'] || 1,
        timeWindowBuffer: this.settings['default13'] || 0,
        groupByTimeWindow: this.settings['default24'] || false,
        groupByWeekDate: this.settings['default32'] || false
      });

      return this.requestAuth.post('ALGORITHM', endpoint, params, payload);
    }
  }, {
    key: "adhocAssign",
    value: function adhocAssign(payload) {
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.requestAuth.post('ALGORITHM', 'v1/core/manualassigncombineroutes', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        removeOverflow: this.settings['default1'] || false,
        // google: this.settings['default5'] || false,
        google: true,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        maxTime: 24,
        combineRoute: true
      }, param), payload);
    }
  }, {
    key: "calculateETA",
    value: function calculateETA(payload) {
      var params = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        code: payload.code,
        lock: payload.locked
      });

      if (this.settings['default2']) {
        params['timeWindow'] = true;
        params['timeWindowBuffer'] = this.settings['default13'];
      }

      return this.requestAuth.post('ROUTING', 'v1/core/lastmile/eta', params, payload);
    }
  }, {
    key: "getTrucksSchedule",
    value: function getTrucksSchedule(param) {
      return this.requestAuth.get('ROUTING', 'v1/core/truckschedule', _objectSpread(_objectSpread(_objectSpread({}, this.requestParameters), param), {}, {
        limit: 500,
        page: 1
      }));
    }
  }]);
  return LastMileDeliveryPriceriteAPI;
}();

exports.LastMileDeliveryPriceriteAPI = LastMileDeliveryPriceriteAPI;